// extracted by mini-css-extract-plugin
module.exports = {"modal-reload":"modal-feedback_modal-reload__3K_9b","loader":"modal-feedback_loader__141Cw","close":"modal-feedback_close__jfZFa"};